var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcJp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3 -2V22H29V-2H-3Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597_43959",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -2,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3 -2V22H29V-2H-3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597_43959)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17.5C17.1421 17.5 20.5 14.1421 20.5 10C20.5 5.85786 17.1421 2.5 13 2.5C8.85786 2.5 5.5 5.85786 5.5 10C5.5 14.1421 8.85786 17.5 13 17.5Z",
    fill: "#E31D1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJp);
export default __webpack_public_path__ + "static/media/ic_jp.ae6c3eca23aac04d524df6cdbc181c65.svg";
export { ForwardRef as ReactComponent };